import ServiceBusController from "servicestack/service-bus.controller";
import COOKIE_CONTENT_PROMPT from "emun.auth/cookie-consent/cookie-consent-prompt.htm";

export default class CookieConsentController extends ServiceBusController {
  $onInit() {
    const $ctrl = this;
    if (!$ctrl.$ioc("$localStorage").cookieConsent) {
      return $ctrl.$modals
        .open({
          size: "cookie-consent",
          backdrop: false,
          templateUrl: COOKIE_CONTENT_PROMPT,
          placement: "bottom",
          controller() {
            const $prompt = this;
            $prompt.$main = $ctrl;
          },
          bindToController: true,
          controllerAs: "$ctrl",
        })
        .result.then(() => {
          $ctrl.$ioc("$localStorage").cookieConsent = new Date();
        });
    }
  }
}
